import { user, alerts } from '../store.js';
import { get, writable } from 'svelte/store';
import { ServiceState, API_BASE_URL } from '../constants.js';
import { auth } from '../firebase/config.js';
import { insertAlertStats, insertAlertDetails } from '../firebase/db.js';
import moment from 'moment';
import { isValidEmail, isValidPhoneNumber } from '../util.js';

export const AlertService = () => {

  const progress = writable({
    status: ServiceState.IDLE,
    alert: 0,
    alerts: 0
  })

  const { subscribe, set, update } = progress;

  const send = async (alert, test=false) => {

    const token = await auth.currentUser.getIdToken(true);

    //console.log('stats', alert.alertStats);

    const alertStats = {
      account_id: get(user).account_id,
      emailCount: 0,
      smsCount: 0,
      voiceCount: 0,
      emailSubject: 'N/A',
      emailBody: 'N/A',
      smsContent: 'N/A',
      voiceContent: 'N/A',
      voiceBroadcastID: 0,
      smsBroadcastID: 0,
      created: moment().unix()
    }

    // send sms
    if(alert.sms.recipients.length && !test) {
      const recipients = [
        ...new Set(alert.sms.recipients)
      ]
        .map(recipient => ({ phoneNumber: recipient}))
        .filter(recipient => !recipient.phoneNumber.includes('000-0000'))
        .filter(recipient => isValidPhoneNumber(recipient.phoneNumber));

      const smsResponse = await fetch(`${API_BASE_URL}/sms`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: `${get(user).company} - ${alert.voice.label}`,
          labels: [alert.sms.label],
          recipients: recipients,
          message: alert.sms.message,
          start: true
        })
      });

      if (!smsResponse.ok) {
        console.log('sms failed')
      } else {
        const response = await smsResponse.json();
        alertStats.smsCount = recipients.length;
        alertStats.smsBroadcastID = response.broadcastID;
        alertStats.smsContent = alert.sms.message;
      }
    }

    // send voice
    if(alert.voice.recipients.length) {
      const recipients = [
        ...new Set(alert.voice.recipients)
      ]
        .map(recipient => ({ phoneNumber: recipient}))
        .filter(recipient => !recipient.phoneNumber.includes('000-0000'))
        .filter(recipient => isValidPhoneNumber(recipient.phoneNumber));
      
      const schedules = [];
      const timeZone = get(user).timezone ? get(user).timezone : 'US/Central'

      if ( alert.voice.voice_send_date.trim()) {
        const hourMinute = alert.voice.voice_send_time.split(':');
        const dayMonthYear = moment(alert.voice.voice_send_date, 'YYYY-MM-DD');
        schedules.push(
          {
            startTimeOfDay: {
              hour: hourMinute[0],
              minute: hourMinute[1],
              second: 0
            },
            stopTimeOfDay: {
              hour: parseInt(hourMinute[0]) > 23 ? 0 : parseInt(hourMinute[0]) + 1,
              minute: hourMinute[1],
              second: 0,
              nano: 0
            },
            timeZone,
            startDate: {
              year: dayMonthYear.year(),
              month: dayMonthYear.month(),
              day: dayMonthYear.date(),
            }
          }
        )
      }

      const voiceAlertBase = {
        name: `${get(user).company} - ${alert.voice.label}`,
        fromNumber: alert.voice.from,
        labels: [alert.voice.label],
        recipients: recipients,
        answeringMachineConfig: "AM_AND_LIVE",
        sounds: {
          liveSoundText: alert.voice.message,
          machineSoundText: alert.voice.message,
          liveSoundTextVoice: alert.voice.voice_sound,
          machineSoundTextVoice: alert.voice.voice_sound
        },
        resumeNextDay: true
      };

      // if schedule has been set, add it to the alert
      const voiceAlert = schedules.length ?
        {...voiceAlertBase, schedules } :
        voiceAlertBase;

      const voiceResponse = await fetch(`${API_BASE_URL}/voice`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(voiceAlert)
      });

      if(!voiceResponse.ok) {
        console.log('voice failed');
      } else {
        const response = await voiceResponse.json();
        alertStats.voiceCount = recipients.length,
        alertStats.voiceBroadcastID = response.broadcastID;
        alertStats.voiceContent = alert.voice.message;
      }
    }

    // send email
    // send in 1000 email batches
    if(alert.email.recipients.length && !test) {
      const recipients = [
        ...new Set(alert.email.recipients)
      ]
        .filter(email => isValidEmail(email));
      const emailResponse = await fetch(`${API_BASE_URL}/mail`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          subject: alert.email.subject,
          body: alert.email.body,
          recipients: recipients,
          from: alert.email.from,
          replyTo: alert.email.replyTo,
          fromName: alert.email.fromName
        })
      });

      if(!emailResponse.ok) {
        console.log('email failed');
      } else {
        alertStats.emailCount = recipients.length;
        alertStats.emailSubject = alert.email.subject,
        alertStats.emailBody = alert.email.body
      }
    }
    if(!test) {
      const res = await insertAlertStats(alertStats);
      //console.log(res.id);
      //console.log('details', alert.alertStatDetail);
      await insertAlertDetails(res.id, alert.alertStatDetail);
      alerts.set([...get(alerts), alertStats]);
    }
    return alertStats;

  }

  return {
    subscribe, set, update,
    send
  }
}